let pageConfig = {};

// 列表展示项
pageConfig.listColumns = [
    {
        label: '运营商名称',
        props: 'corpName',
        minWidth: 200,
        formatter: function formatter(row, column, cellValue, index) {
            // 做判断
            if (row.dealerCalcDto) {
                return row.dealerCalcDto.dealerName;
            }
            else {
                return ''
            }
        }
    },
    {
        label: '未入账金额',
        props: 'pileTypeCode',
        minWidth: 300,
        formatter: function formatter(row, column, cellValue, index) {
            // 做判断
            if (row.dealerCalcDto) {
                return row.dealerCalcDto.uncheckFee;
            }
            else {
                return ''
            }
        }
    },
    {
        label: '待提现金额',
        props: 'pileTypeNo',
        minWidth: 200,
        formatter: function formatter(row, column, cellValue, index) {
            // 做判断
            if (row.dealerCalcDto) {
                return row.dealerCalcDto.unCashOutFee;
            }
            else {
                return ''
            }
        }
    },
    {
        label: '已提现金额',
        props: 'interfaceTypeName',
        minWidth: 200,
        formatter: function formatter(row, column, cellValue, index) {
            // 做判断
            if (row.dealerCalcDto) {
                return row.dealerCalcDto.cashOutedFee;
            }
            else {
                return ''
            }
        }
    },
    {
        label: '服务费',
        props: 'servFee',
        minWidth: 200,
        formatter: function formatter(row, column, cellValue, index) {
            // 做判断
            if (row.dealerCalcDto) {
                return row.dealerCalcDto.serviceFee;
            }
            else {
                return ''
            }
        }
    },
    {
        label: '订单收入',
        props: 'useStateName',
        minWidth: 120,
        formatter: function formatter(row, column, cellValue, index) {
            // 做判断
            if (row.dealerCalcDto) {
                return row.dealerCalcDto.actFee;
            }
            else {
                return ''
            }
        }
    },
    {
        label: '充电量（kW·h）',
        props: 'chargeVal',
        minWidth: 200,
        formatter: function formatter(row, column, cellValue, index) {
            // 做判断
            if (row.dealerCalcDto) {
                return row.dealerCalcDto.chargeVal;
            }
            else {
                return ''
            }
        }
    },
    {
        label: '最后审核时间',
        props: 'lastModifiedWhen',
        minWidth: 180,
        formatter: function formatter(row, column, cellValue, index) {
            // 做判断
            if (row.dealerCalcDto) {
                return row.dealerCalcDto.lastReviceDate;
            }
            else {
                return ''
            }
        }
    },
];

// // 面包屑
pageConfig.listBreadCrumb = [{
    type: 'title',
    name: '首页',
},
{
    type: 'title',
    name: '财务管理'
},
{
    type: 'title',
    name: '入账审核'
}];

// 列表-表格属性
pageConfig.tableConfig = {
    showSelection: false,
    showIndex: true,
};

// 列表-表格属性
pageConfig.detailTableConfig = {
    showSelection: true,
    showIndex: true,
};

// 列表-分页参数
pageConfig.pagination = {
    current: 1,
    total: 0,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100],
}
// 列表-编辑操作
pageConfig.tableEditObj = {
    editKey: 'id',
    editRouter: 'financeReviewDetail',
};

// 路由
pageConfig.listRouter = 'financeReviewList';

pageConfig.detailRouter = 'financeReviewDetail';

// 详情的面包屑
pageConfig.detailBreadCrumb = [{
    type: 'title',
    name: '首页',
},
{
    type: 'title',
    name: '财务管理'
},
{
    type: 'router',
    name: '财务审核',
    router: 'financeReviewList'
},
{
    type: 'title',
    name: '审核详情'
}];

pageConfig.formRules = {
    fiReviewFlg: [{
        required: true,
        message: '请选择审核结果',
        trigger: 'change'
    }],
};



export default pageConfig;